// i18n
import { translateInComponent, translate } from 'infras/i18n';
import translations from './i18n.json';
import Image from 'presentations/views/components/atoms/Image';
import styled from '@emotion/styled';
import { spacing } from 'presentations/views/styles';
import CopyToClipboard from 'react-copy-to-clipboard';
import { VideoServiceType } from 'domains/models/calendar/videoServiceType';
import { SyntheticEvent, useContext } from 'react';
import { formatVideoServiceTypeName } from 'presentations/views/helpers/formatter';
import Button from 'presentations/views/components/atoms/Button';
import IconButton from 'presentations/views/components/atoms/IconButton';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  DashboardPortalContext,
  setSuccessMessage,
} from 'presentations/reducers/DashboardPortal';
import { primary } from 'presentations/views/styles/color';

interface Props {
  videoServiceType: VideoServiceType;
  url: string;
  className?: string;
  isShowTitleServiceName?: boolean;
}

export default function Component(props: Props) {
  const { dispatch } = useContext(DashboardPortalContext);
  const formatVideoServiceImage = (videoServiceType: VideoServiceType) => {
    switch (videoServiceType) {
      case VideoServiceType.Zoom:
        return 'locations/3.svg';
      case VideoServiceType.GoogleMeet:
        return 'locations/4.svg';
      case VideoServiceType.MicrosoftTeams:
        return 'locations/6.svg';
      default:
        break;
    }
    return 'locations/1.svg';
  };

  const onCopy = () => {
    dispatch(setSuccessMessage(t('Copied Text')));
  };

  const imageUrl = formatVideoServiceImage(props.videoServiceType);
  const name = formatVideoServiceTypeName(props.videoServiceType);

  const onClickVideoLink = (e: SyntheticEvent<HTMLButtonElement>) => {
    window.open(props.url);
  };

  const t = translateInComponent([translations]);

  return (
    <VideoContainer className={props.className}>
      <VideoLink onClick={onClickVideoLink} variant="outlined">
        {imageUrl && name && <LocationImage src={imageUrl} alt={name} />}
        {props.isShowTitleServiceName ? t('Join Name', { name }) : t('Join')}
      </VideoLink>
      <VideoCopy>
        <CopyToClipboard text={props.url} onCopy={onCopy}>
          <VideoCopyIconButton>
            <VideoCopyIcon name="file_copy_outlined" />
          </VideoCopyIconButton>
        </CopyToClipboard>
      </VideoCopy>
    </VideoContainer>
  );
}

const VideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const VideoLink = styled(Button)`
  flex: 1;
`;
const VideoCopy = styled.div`
  margin-left: ${spacing(8)};
`;
const VideoCopyIconButton = styled(IconButton)`
  :hover {
    color: ${primary};
  }
`;
const VideoCopyIcon = styled(Icon)`
  width: 18px !important;
  height: 18px !important;
`;

const LocationImage = styled(Image)`
  margin-right: ${spacing(8)};
  width: 24px;
  height: 24px;
`;
